import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Stack, styled } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IConsultant } from 'wisestep-api';
import { ControlledTextInput, Label, WsButton, WsColors } from 'wisestep-base';
import { string, object } from 'yup';

interface IPrimaryInfoProps {
  newConsultant: (data: any) => void;
  postNewConsultant: () => Promise<void>;
  consultantData?: Partial<IConsultant>;
  setCurrentTab: Dispatch<SetStateAction<number>>;
}

const OwnerHeading = styled(Label)(() => ({
  color: WsColors.TheBlues600,
  fontWeight: 'bold',
  margin: '10px 0px',
}));

const OwnerInfo = ({
  newConsultant,
  postNewConsultant,
  consultantData,
  setCurrentTab,
}: IPrimaryInfoProps) => {
  const schema = object().shape({
    ownerName: string().required('ownerName is required'),
    ownerId: string().required('ownerEmail is required'),
  });
  const methods = useForm({
    resolver: yupResolver(schema),
    ...(consultantData && {
      defaultValues: {
        ownerName: consultantData.ownerName,
        ownerId: consultantData.ownerId,
        ownerPhone: consultantData.ownerPhone,
        ownerCompany: consultantData.ownerCompany,
      },
    }),
  });
  const onSubmit = (data) => {
    newConsultant(data);
    postNewConsultant();
  };

  return (
    <FormProvider {...methods}>
      <OwnerHeading>Owner Info</OwnerHeading>
      <Grid container spacing={3} columnSpacing={3} component="form">
        <Grid item xs={6}>
          <ControlledTextInput
            name="ownerName"
            labelText="Owner Name *"
            type="text"
            fullWidth
            placeholder="Owner Name"
            required
          />
        </Grid>
        <Grid item xs={6}>
          <ControlledTextInput
            name="ownerId"
            labelText="Owner Email *"
            type="text"
            fullWidth
            placeholder="Owner Email"
            required
          />
        </Grid>
        <Grid item xs={6}>
          <ControlledTextInput
            name="ownerPhone"
            type="text"
            fullWidth
            placeholder="Owner Phone"
            labelText="Owner Phone"
          />
        </Grid>
        <Grid item xs={6}>
          <ControlledTextInput
            name="ownerCompany"
            labelText="Owner Company"
            type="text"
            fullWidth
            placeholder="Owner Company "
          />
        </Grid>
        <Stack width="100%" direction="row" justifyContent="end" mt={3} gap={2}>
          <WsButton onClick={() => setCurrentTab(1)}>Previous</WsButton>
          <WsButton onClick={methods.handleSubmit(onSubmit, (e) => console.log(e))}>
            Submit
          </WsButton>
        </Stack>
      </Grid>
    </FormProvider>
  );
};

export default OwnerInfo;
